import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Form for rule_type='lm_growth_pct'.
 * rule_value shape: { pct: <number> }
 * Target = M-1 result × (1 + pct/100).
 */
const LmGrowthRuleForm = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();
  const v = value?.pct ?? '';

  return (
    <div className="space-y-2">
      <label className="block text-xs uppercase tracking-widest text-muted-foreground font-semibold">
        {t('admin.objectiveRules.form.lmGrowthPct.pct', 'Growth percentage')}
      </label>
      <div className="flex items-center gap-2">
        <input
          type="number"
          step="any"
          disabled={disabled}
          value={v}
          onChange={(e) =>
            onChange({ pct: e.target.value === '' ? null : Number(e.target.value) })
          }
          className="w-full px-3 py-2 rounded-lg bg-card border border-border text-foreground text-base tabular-nums outline-none focus:border-accent focus:ring-1 focus:ring-accent/30 disabled:opacity-60"
          placeholder="30"
        />
        <span className="text-sm font-semibold text-muted-foreground">%</span>
      </div>
      <p className="text-xs text-muted-foreground">
        {t(
          'admin.objectiveRules.form.lmGrowthPct.help',
          'Target = last-month result × (1 + pct/100). Example: 30% means +30% over M-1.'
        )}
      </p>
    </div>
  );
};

export default LmGrowthRuleForm;
